/**
 * Check if a given object implements the TicketTemplateManagementInfo interface.
 */
export function instanceOfTicketTemplateManagementInfo(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function TicketTemplateManagementInfoFromJSON(json) {
    return TicketTemplateManagementInfoFromJSONTyped(json, false);
}
export function TicketTemplateManagementInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'],
    };
}
export function TicketTemplateManagementInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
    };
}
